import {
  BarElement,
  CategoryScale,
  Filler,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
} from "chart.js";

export const registerBaasHomeLineChart = (ChartJS) => {
  ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip);
};

export const registerBaasHomeBarChart = (ChartJS) => {
  ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip);
};

export const buildBaasHomeLineChartOptions = (isDark, formatTooltipValue) => ({
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    mode: "index",
    intersect: false,
  },
  plugins: {
    legend: { display: false },
    tooltip: {
      backgroundColor: isDark ? "#333" : "#242424",
      titleFont: { size: 12, weight: "600" },
      bodyFont: { size: 12 },
      padding: 10,
      cornerRadius: 8,
      displayColors: false,
      callbacks: {
        label: (context) => formatTooltipValue(context.parsed.y),
      },
    },
  },
  scales: {
    x: {
      grid: {
        display: true,
        color: isDark ? "rgba(255, 255, 255, 0.06)" : "rgba(229, 231, 235, 0.6)",
        drawBorder: false,
      },
      ticks: {
        color: isDark ? "#6b7280" : "#9ca3af",
        font: { size: 10 },
        maxTicksLimit: 8,
        maxRotation: 0,
      },
      border: { display: false },
    },
    y: {
      display: false,
      beginAtZero: true,
      grid: { display: false },
    },
  },
  elements: {
    line: {
      tension: 0.35,
      borderWidth: 2,
    },
    point: {
      radius: 0,
      hoverRadius: 4,
      hitRadius: 12,
    },
  },
});

export const buildBaasHomeSparklineOptions = (isDark, formatTooltipValue) => ({
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    mode: "index",
    intersect: false,
  },
  plugins: {
    legend: { display: false },
    tooltip: {
      backgroundColor: isDark ? "#333" : "#242424",
      titleFont: { size: 11, weight: "600" },
      bodyFont: { size: 11 },
      padding: 8,
      cornerRadius: 6,
      displayColors: false,
      callbacks: {
        title: () => "",
        label: (context) => formatTooltipValue(context.parsed.y),
      },
    },
  },
  scales: {
    x: {
      display: false,
      grid: { display: false },
      border: { display: false },
    },
    y: {
      display: false,
      beginAtZero: true,
      grid: { display: false },
      border: { display: false },
    },
  },
  elements: {
    line: {
      tension: 0.35,
      borderWidth: 1.5,
    },
    point: {
      radius: 0,
      hoverRadius: 3,
      hitRadius: 8,
    },
  },
});

export const buildBaasHomeStackedBarOptions = (isDark, formatTooltipValue) => ({
  responsive: true,
  maintainAspectRatio: false,
  indexAxis: "y",
  plugins: {
    legend: { display: false },
    tooltip: {
      backgroundColor: isDark ? "#333" : "#242424",
      titleFont: { size: 12, weight: "600" },
      bodyFont: { size: 12 },
      padding: 10,
      cornerRadius: 8,
      callbacks: {
        label: (context) => {
          const label = context.dataset.label || "";
          return `${label}: ${formatTooltipValue(context.parsed.x)}`;
        },
      },
    },
  },
  scales: {
    x: {
      stacked: true,
      display: false,
      grid: { display: false },
    },
    y: {
      stacked: true,
      display: false,
      grid: { display: false },
    },
  },
});
